module.exports = __webpack_public_path__ + "static/media/0xA0c9a4ebC96737E8f9f61A88D6361Bb26250a068.6ec34ace.svg";